import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersDetailFormsEditControllerModule } from './controllers/OrdersDetailFormsEditController';

export const OrdersDetailFormsEditView = angular
  .module('acme.view.application.orders.detail.forms.edit', [
    uiRouter,
    'ui.bootstrap',
    OrdersDetailFormsEditControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.orders.detail.forms.edit',
      url: '/:responseId/edit',
      views: {
        'subview-main@application.orders': {
          controller: 'OrdersDetailFormsEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/forms/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Form Response',
        /** Secure With Permissions **/
        permissions: ['FORM_RESPONSE_VIEW'],
      },
      resolve: {
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
        OrderFormResponseData: [
          'ApiService',
          '$stateParams',
          function (ApiService: ApiService, $stateParams: StateParams) {
            return ApiService.orders.forms.response({
              orderId: $stateParams.orderId,
              responseId: $stateParams.responseId,
            });
          },
        ],
      },
    });
  }).name;
